import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function PTWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1810">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1811">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1812">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1813">
            WHY CHOOSE BE CLINICAL FOR PDO THREADS
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1814"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1815">
            <p data-id="element-1816">
              Choosing Be CLINICAL for PDO Threads means you are working with a
              trusted, evidence-based medical and aesthetic clinic dedicated to
              serving the San Francisco Bay Area. Founded in 2017 under the
              leadership of Fiona Frie MD, our physician-owned and operated
              facility specializes in preventative aging and aesthetic
              enhancements. Our PDO Thread treatments are performed by highly
              trained medical professionals with the most advanced techniques
              and skill. We use the highest grade FDA approved PDO Threads for
              optimal results.
            </p>
            <p data-id="element-1817">
              Our expert practitioners have a deep understanding of facial
              anatomy, ensuring precise and effective PDO Thread treatments.
              Trust Be CLINICAL to help you achieve natural-looking results and
              rejuvenate your appearance with confidence. We welcome you to
              schedule your complimentary consultation today!
            </p>
          </div>

          <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1818">
            BOOK CONSULT
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}